import React from 'react';
import styled from 'styled-components';
import EditIcon from "../../../../assets/images/icon/EditIcon";
import dayjs from "dayjs";

// rgba(255, 179, 186, 1)
// rgba(186, 255, 201, 1)
// rgba(186, 225, 255, 1)
// rgba(255, 200, 221, 1)
const returnStatus = (status) => {
    switch (status) {
        case "SCHEDULED":{
            return "rgba(186, 225, 255, 1)"
        }
        case "PENDING":{
            return "rgba(255, 179, 186, 1)"
        }
        case "JOIN A CALL":{
            return "rgba(186, 255, 201, 1)"
        }

    }
}
// [0].coachingApplication.coachingStatus
const SchListItem = (props) => {
    console.log("@props?.data2",props?.data);
    const returnData = () => {
        const endTime = props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.startTime;
        const d = Number(props?.data?.coachingApplication?.liveCoaching?.duration);
        const currentDate = dayjs().format('YYYY-MM-DD');

        // Combining currentDate and endTime to form a valid datetime format
        const combinedEndTime = `${currentDate} ${endTime}`;

        console.log("@d",d, endTime);
        const newEndTime = dayjs(combinedEndTime)?.add(d,"minute")?.format("HH:mm:ss")

        return newEndTime
    };

    console.log("@returnData()",returnData());
return(
  <Container>
      <Status>
        <div className={"circle"}
            style={{
                background:returnStatus(props?.data?.coachingApplication?.coachingStatus)
            }}
        >

        </div>
          <TimeArea>
              <ListTitle>
                  Time
              </ListTitle>
              <p>
                  {props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.startTime &&
                      props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.startTime?.slice(0,5)} -&nbsp;
                  {props?.data?.coachingApplication?.liveCoaching?.liveCoachingSlot?.endTime &&
                      returnData()?.slice(0,5)}
              </p>
          </TimeArea>
      </Status>

      <TitleArea>
          <ListTitle>
              Coaching request title
          </ListTitle>
          <p>
              {props?.data?.coachingApplication?.liveCoaching?.title || "-"}
          </p>
      </TitleArea>
      <StuName>
          <ListTitle>
              Student name
          </ListTitle>
          <p>
              {props?.data?.userName || "-"}
          </p>
      </StuName>
      <Btn>
          <div
              onClick={() => {
                  props.onClickPopup()
              }}
              className="editIcon" style={{cursor: "pointer"}}>

              <span style={{marginTop: 3, marginRight:0}}>Edit</span>
              <EditIcon/>
          </div>
      </Btn>
  </Container>
)

}
export default SchListItem;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px;
    border-bottom: rgba(51, 51, 51, 0.2) solid 1px;
   
    & > div {
    }
`;
const Status = styled.div`
    width: 20%;
    display: flex;
    align-items: center;
    .circle {
        margin-right: 30px;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: rgba(255, 179, 186, 1);
    }
`
const TimeArea = styled.div`
    display: flex;
    flex-direction: column;
`
const TitleArea = styled.div`
    width: 30%;
    p{
        font-family: Europa-Light;
        font-size: 18px;
        font-weight: 300;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }
`
const StuName = styled.div`
    width: 30%;
    p{
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }
`
const Btn = styled.div`
    .editIcon{
        height: 30px;
        padding: 8px 16px 8px 17px;
        border-radius: 5px;
        gap: 10px;
        background: rgba(51, 51, 51, 1);
        color: #fff;
        display: flex;
        align-items: center;
        span{
            font-family: Europa-Regular;
            font-size: 12px;
            font-weight: 400;
            text-align: left;
        }
        svg {
            path{
                fill: #fff;
            }
        width: 14px;
        height: 14px;
        }
    }
`
const ListTitle = styled.span`
    display: flex;
    font-family: Europa-Bold;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: #333;
    margin-bottom: 10px;
`